var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningCircleRedBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.62,
    height: 51.62,
    viewBox: "0 0 51.62 51.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CVV_warning_circle_icon",
    "data-name": "CVV warning circle icon",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-circle",
    "data-name": "Icon feather-alert-circle",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_379",
    "data-name": "\\uD328\\uC2A4 379",
    d: "M50.62,26.81A23.81,23.81,0,1,1,26.81,3,23.81,23.81,0,0,1,50.62,26.81Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_380",
    "data-name": "\\uD328\\uC2A4 380",
    d: "M18,12v9.524",
    transform: "translate(5.81 2.286)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_381",
    "data-name": "\\uD328\\uC2A4 381",
    d: "M18,24h0",
    transform: "translate(5.81 9.334)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleRedBorder);
export default __webpack_public_path__ + "static/media/warning_circle_red_border.8818b268a1378046197686dd575028f5.svg";
export { ForwardRef as ReactComponent };